import { FC } from 'react'

import { MainLayoutProps } from '../../layouts'
import { AdsEmitterBannerProps } from '../../components/AdsEmitterBanner'
import { AdsSortingFiltersProps } from '../../components/AdsSortingFilters'
import AdsTableItem, { AdsTableItemProps } from '../../components/AdsTableItem'
import { AdsGridProps } from '../../components/AdsGrid'
import SectionWrapper from '../../components/SectionWrapper'
import { PaginationProps } from '../../components/Pagination'
import { MapProps } from '../../components/Map'

import * as SC from './styled'

export type AdsEmitterListTemplateProps = MainLayoutProps & {
  banner?: AdsEmitterBannerProps
  filters?: AdsSortingFiltersProps
  adsList?: Array<AdsTableItemProps>
  adsGrid?: AdsGridProps
  map?: MapProps
  pagination?: PaginationProps
}

const AdsEmitterListTemplate: FC<AdsEmitterListTemplateProps> = ({
  banner,
  filters,
  adsList,
  adsGrid,
  map,
  pagination,
  ...layout
}) => {
  return (
    <SC.Layout {...layout}>
      {banner && (
        <SC.Container>
          <SC.Banner {...banner} />
        </SC.Container>
      )}
      {filters && (
        <SC.Container>
          <SC.Filters {...filters} />
        </SC.Container>
      )}
      {adsList && (
        <SectionWrapper>
          <SC.Overflow>
            <SC.List>
              {adsList.map((item, index) => (
                <AdsTableItem key={index} {...item} />
              ))}
            </SC.List>
          </SC.Overflow>
        </SectionWrapper>
      )}
      {adsGrid && (
        <SectionWrapper>
          <SC.GridAds {...adsGrid} />
        </SectionWrapper>
      )}
      {map && (
        <SectionWrapper>
          <SC.MapAds {...map} />
        </SectionWrapper>
      )}
      {pagination && (
        <SC.Centered spacing={'small'}>
          <SC.PaginationStyled {...pagination} />
        </SC.Centered>
      )}
    </SC.Layout>
  )
}

export default AdsEmitterListTemplate
